import { Frown } from 'lucide-react';
import { Link } from 'react-router-dom';

import { ExternalApplicationLinks } from '@sandtech-hub-monorepo/ui-kit-site';

interface Props {
  /** The course name, completing "{subject} is taking longer…". */
  subject: string;
}

/**
 * Shown when polling for Savanna's curriculum sync gives up without ever
 * getting a flow back - see `InteractiveCourseAccordion`'s `pollingExpired`.
 * Distinct from `CurriculumError`: this is not a GraphQL error, just a sync
 * that never caught up, so the copy points at retrying rather than "we
 * couldn't load".
 */
export const CurriculumTimeout = ({ subject }: Props) => (
  <div className="flex items-start gap-2 rounded-xl border border-warning/30 bg-warning/5 p-4 text-sm text-warning">
    <Frown className="mt-0.5 h-4 w-4 shrink-0" />
    <p>
      <span className="font-semibold">{subject}</span> is taking longer than
      usual to load. Try refreshing the page. If the problem persists,{' '}
      <Link
        to={ExternalApplicationLinks.support ?? '#'}
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        contact support
      </Link>
      .
    </p>
  </div>
);
